import axios from 'axios';

import {
  CustomerInvoiceListResponseData,
  CustomerInvoiceParams,
} from 'root/apps/QuoteMachineIntegration/state/CustomerInvoiceResponse';
import { datadogRum } from 'root/datadog/datadogRum';

import { LS_INVOICING_API_ROOT } from '../constants';

export default class CustomerInvoiceService {
  static async fetchCustomerInvoices(
    creditAccountId: string,
    params: CustomerInvoiceParams
  ): Promise<CustomerInvoiceListResponseData> {
    try {
      const invoicingCreditAccountId = `ls-retail_${creditAccountId}`;

      const { data } = await axios.get<CustomerInvoiceListResponseData>(
        `${LS_INVOICING_API_ROOT}/credit-accounts/${invoicingCreditAccountId}/invoices`,
        {
          params: {
            page: params.page,
            limit: params.limit,
            ...(params.textSearch && { textSearch: params.textSearch }),
            ...(params.sort && { sort: params.sort }),
          },
        }
      );

      return data;
    } catch (error) {
      datadogRum.addError(error as Error, {
        creditAccountId,
        params,
        message: `Failed to fetch customer invoices for credit account ${creditAccountId} with params ${JSON.stringify(
          params
        )}`,
      });
      throw error;
    }
  }
}
